import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from '@/store/index.js'
import smoothscroll from 'smoothscroll-polyfill';
import { isExpired, logOut, loginPath } from '../plugins/auth'

smoothscroll.polyfill();

Vue.use(VueRouter)

// 全権限共通のroute
const routes = [
  {
    path: '/sign_in',
    name: 'SignIn',
    component: () => import('../views/SignIn.vue')
  },
  {
    // おためし活動用のページ（新学社HPからリンク）
    path: '/otameshi',
    name: 'Otameshi',
    component: () => import('../views/Otameshi.vue')
  },
  {
    path: '/sso/callback',
    name: 'SsoCallback',
    component: () => import('../views/SsoCallback.vue')
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('../views/Error.vue')
  },
  {
    path: '/not_found',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue')
  },
  {
    path: '/env_check',
    name: 'EnvCheck',
    component: () => import('../views/EnvCheck.vue')
  },
]

// 権限ごとのrouteを読み込む
const files = require.context('.', false, /\.js$/)
files.keys().reduce((routes, filename) => {
  if (filename === './index.js') return routes

  const addRoutes = files(filename).default
  const namespace = filename.replace(/(\.\/|\.js)/g, '')

  addRoutes.forEach(route => {
    const componentName = route.name;
    route.path = '/' + namespace + route.path;
    route.component = () => import(`../views/${namespace}/${componentName}.vue`);
    // 権限ごとのrouteでnameが被るとエラーになるのでnameをnamespaceを使って書き換えておく
    route.name = namespace + route.name;

    // 一定時間操作がなかったらログアウトさせる
    route.beforeEnter = (to, from, next) => {
      if (isExpired()) {
        // お試しアカウントは/otameshiへ。logOutでstoreがクリアされる前に判定
        const path = loginPath()
        logOut()
        Vue.prototype.$axios.delete('/api/v1/auth/sign_out')
        Vue.toasted.global.error({ message: '一定時間操作がありませんでした。お手数ですが、再度ログインの上ご利用をお願いします。' })
        next(path);
      } else {
        Store.commit('user/setLastOperatedDate', { lastOperatedDate: new Date })
        next()
      }
    }
    routes.push(route)
  })

  return routes
}, routes)

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  // ルートpathは/sign_in
  if (to.path === '/') {
    next('/sign_in')
  }

  // 動作環境チェック画面への遷移は許容
  else if (to.path === '/env_check') {
    Store.commit('setCurrentPath', { path: to.path })
    next()
  }

  // 申し込み画面への遷移も許容
  else if (to.path.includes('/enrollment')) {
    Store.commit('setCurrentPath', { path: to.path })
    next()
  }

  // SSOコールバック画面への遷移も許容
  else if (to.path === '/sso/callback') {
    Store.commit('setCurrentPath', { path: to.path })
    next()
  }

  // おためし活動用ページへの遷移も許容（未ログインで表示）
  else if (to.name === 'Otameshi') {
    Store.commit('setCurrentPath', { path: to.path })
    next()
  }

  // ログインしていなかったらsign_in画面へ遷移させる
  else if (to.name !== 'SignIn' && !Store.state.user.accessToken) {
    Store.commit('setCurrentPath', { path: '/sign_in' })
    next('/sign_in')
  }

  // adminでログイン中にteacherがつくURLへ遷移 or teacherでログイン中にadminがつくURLへ遷移
  // => 404 NotFound
  else if (Store.getters['user/isAdmin'] && to.path.includes('teacher')) { next('/not_found') }
  else if (Store.getters['user/isTeacher'] && to.path.includes('admin')) { next('/not_found') }
  // 存在しないページへ遷移 => 404 NotFound
  else if (!router.options.routes.find(route => route.name === to.name)) { next('/not_found') }
  else {
    // menuアイコンがアクティブならfalseにする
    if (Store.state.drawer) Store.commit('setDrawer', { drawer: false })
    Store.commit('setCurrentPath', { path: to.path })
    next()
  }
})

export default router
